export enum UserTypes {
  Earner = 'CreditEarner',
  Processor = 'CreditProcessor',
  Admin = 'Admin',
}
